<div class="painel-simples" [class.expanded]="expandido">
  <button
    type="button"
    class="header"
    [class.expanded]="expandido"
    (click)="alternarExpansao()"
  >
    <img class="chevron px-4" src="assets/icons/down.svg" alt="" />
    <span class="title-text">{{ nome }}</span>
    <img class="chevron py-4" src="assets/icons/down.svg" alt="" />
  </button>

  <div *ngIf="expandido" class="accordion-body bg-gray-100 px-6 pt-6 pb-10">
    <div class="table-content rounded-sm sm-shadow">
      <app-tabela
        [cabecalhoCustomizado]="true"
        ngSkipHydration
      >
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-left-header text-body-lg">Etapa/Modalidade</th>
            <th class="top-header text-body-lg">Total matrículas (parcial, integral e noturno)</th>
            <th class="top-header text-body-lg">Matrículas Diurno (Parcial e Integral)</th>
            <th class="top-header text-body-lg">Matrículas em Tempo Integral</th>
            <th class="top-header text-body-lg">% Matrículas tempo integral</th>
            <th class="top-right-header text-body-lg">Matrículas Noturno</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <tr *ngIf="!exibirCrechePorIdade" class="cells-row">
            <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Creche</td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.creche.totalDiurnoENoturno"
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.creche.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.creche.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.creche.porcentagemIntegral"
                (ngModelChange)="atualizarValores()"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="right-cell">
              <input
                disabled
                class="disabled-input"
                [value]="tabela.creche.noturno"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>

          <!-- #1128: creche segmentada por idade (flag 1104-creche-idade) -->
          <ng-container *ngIf="exibirCrechePorIdade">
            <!-- Creche (agregado) = soma dos segmentos por idade, somente leitura -->
            <tr class="cells-row">
              <td class="left-cell align-left text-bold text-charcoal-800 text-body-lg">Creche</td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-bold text-body-lg text-charcoal-800"
                  [value]="tabela.creche.totalDiurnoENoturno"
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-bold text-body-lg text-charcoal-800"
                  [value]="tabela.creche.diurno"
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-bold text-body-lg text-charcoal-800"
                  [value]="tabela.creche.totalIntegral"
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-bold text-body-lg text-charcoal-800"
                  [value]="tabela.creche.porcentagemIntegral"
                />
              </td>
              <td class="right-cell">
                <input
                  disabled
                  class="disabled-input"
                  [value]="tabela.creche.noturno"
                />
              </td>
            </tr>

            <!-- Creche: 0 a 12 meses -->
            <tr class="cells-row">
              <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Creche: 0 a 12 meses</td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.crecheMenor1Ano.totalDiurnoENoturno"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.crecheMenor1Ano.diurno"
                  (ngModelChange)="atualizarValores()"
                  appOnlyNumbers
                  appMaxFour
                  appNotEmpty
                  appNoLeftZero
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.crecheMenor1Ano.totalIntegral"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.crecheMenor1Ano.porcentagemIntegral"
                  (ngModelChange)="atualizarValores()"
                  [maskito]="mask_porcentagem_limpa"
                  appNotEmpty
                />
              </td>
              <td class="right-cell">
                <input
                  disabled
                  class="disabled-input"
                  [value]="tabela.crecheMenor1Ano.noturno"
                />
              </td>
            </tr>

            <!-- Creche: 12 a 24 meses -->
            <tr class="cells-row">
              <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Creche: 12 a 24 meses</td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche1Ano.totalDiurnoENoturno"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche1Ano.diurno"
                  (ngModelChange)="atualizarValores()"
                  appOnlyNumbers
                  appMaxFour
                  appNotEmpty
                  appNoLeftZero
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche1Ano.totalIntegral"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche1Ano.porcentagemIntegral"
                  (ngModelChange)="atualizarValores()"
                  [maskito]="mask_porcentagem_limpa"
                  appNotEmpty
                />
              </td>
              <td class="right-cell">
                <input
                  disabled
                  class="disabled-input"
                  [value]="tabela.creche1Ano.noturno"
                />
              </td>
            </tr>

            <!-- Creche: 25 a 36 meses -->
            <tr class="cells-row">
              <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Creche: 25 a 36 meses</td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche2Anos.totalDiurnoENoturno"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche2Anos.diurno"
                  (ngModelChange)="atualizarValores()"
                  appOnlyNumbers
                  appMaxFour
                  appNotEmpty
                  appNoLeftZero
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche2Anos.totalIntegral"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche2Anos.porcentagemIntegral"
                  (ngModelChange)="atualizarValores()"
                  [maskito]="mask_porcentagem_limpa"
                  appNotEmpty
                />
              </td>
              <td class="right-cell">
                <input
                  disabled
                  class="disabled-input"
                  [value]="tabela.creche2Anos.noturno"
                />
              </td>
            </tr>

            <!-- Creche: 37 a 48 meses -->
            <tr class="cells-row">
              <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Creche: 37 a 48 meses</td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche3Anos.totalDiurnoENoturno"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche3Anos.diurno"
                  (ngModelChange)="atualizarValores()"
                  appOnlyNumbers
                  appMaxFour
                  appNotEmpty
                  appNoLeftZero
                />
              </td>
              <td>
                <input
                  disabled
                  class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                  [value]="tabela.creche3Anos.totalIntegral"
                />
              </td>
              <td>
                <input
                  class="display-input"
                  [(ngModel)]="tabela.creche3Anos.porcentagemIntegral"
                  (ngModelChange)="atualizarValores()"
                  [maskito]="mask_porcentagem_limpa"
                  appNotEmpty
                />
              </td>
              <td class="right-cell">
                <input
                  disabled
                  class="disabled-input"
                  [value]="tabela.creche3Anos.noturno"
                />
              </td>
            </tr>
          </ng-container>
          <tr class="cells-row">
            <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Pré-escola: 4 e 5 anos</td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.preEscola.totalDiurnoENoturno"
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.preEscola.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.preEscola.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.preEscola.porcentagemIntegral"
                (ngModelChange)="atualizarValores()"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="right-cell">
              <input
                disabled
                class="disabled-input"
                [value]="tabela.preEscola.noturno"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Ensino Fundamental - Anos Iniciais</td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoFundamentalIniciais.totalDiurnoENoturno"
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoFundamentalIniciais.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoFundamentalIniciais.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoFundamentalIniciais.porcentagemIntegral"
                (ngModelChange)="atualizarValores()"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="right-cell">
              <input
                disabled
                class="disabled-input"
                [(ngModel)]="tabela.ensinoFundamentalIniciais.noturno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Ensino Fundamental - Anos Finais</td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoFundamentalFinais.totalDiurnoENoturno"
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoFundamentalFinais.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoFundamentalFinais.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoFundamentalFinais.porcentagemIntegral"
                (ngModelChange)="atualizarValores()"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="right-cell">
              <input
                disabled
                class="disabled-input"
                [(ngModel)]="tabela.ensinoFundamentalFinais.noturno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell align-left text-regular text-charcoal-800 text-body-lg">Ensino Médio</td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoMedio.totalDiurnoENoturno"
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoMedio.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.ensinoMedio.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td>
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoMedio.porcentagemIntegral"
                (ngModelChange)="atualizarValores()"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="right-cell">
              <input
                class="display-input"
                [(ngModel)]="tabela.ensinoMedio.noturno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>
          <tr class="cells-row">
            <td class="bottom-left-cell align-left text-regular text-charcoal-800 text-body-lg">EJA</td>
            <td class="bottom-cell">
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.eja.totalDiurnoENoturno"
              />
            </td>
            <td class="bottom-cell">
              <input
                class="display-input"
                [(ngModel)]="tabela.eja.diurno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td class="bottom-cell">
              <input
                disabled
                class="fake-input align-left text-regular text-body-lg text-charcoal-800"
                [value]="tabela.eja.totalIntegral"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
            <td class="bottom-cell">
              <input
                disabled
                class="disabled-input"
                [value]="tabela.eja.porcentagemIntegral"
                [maskito]="mask_porcentagem_limpa"
                appNotEmpty
              />
            </td>
            <td class="bottom-right-cell">
              <input
                class="display-input"
                [(ngModel)]="tabela.eja.noturno"
                (ngModelChange)="atualizarValores()"
                appOnlyNumbers
                appMaxFour
                appNotEmpty
                appNoLeftZero
              />
            </td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>
  </div>
</div>
